const PrivacyPolicyPage = props => (
    <div className="legal-container">
        <div className="container">
            <h2>Privacy Policy</h2>
            <p>
By using the BulletTrain.io website ("service"), or any services of Bullet Train Ltd, you are
                agreeing to be bound by the following privacy policy ("privacy policy"). If you are entering into this
                agreement on behalf of a company or other legal entity, you represent that you have the authority to
                bind such entity, its affiliates and all users who access our services through your account to these
                terms and conditions, in which case the terms "you" or "your" shall refer to such entity, its affiliates
                and users associated with it. If you do not have such authority, or if you do not agree with these terms
                and conditions, you must not accept this agreement and may not use the services.
            </p>

            <h5>Who Are We?</h5>
            <p>
Bullet Train is a Software-as-a-Service (SaaS) platform provider that serves companies looking to
                implement feature flags in their overall software development lifecycle. Feature flags allow software
                developers to change application behavior from outside of the application without redeploying their
                code. This has a number of benefits including a separation of risks, ability to deliver different
                experiences in a targeted manner, and the lower administrative burden of software release. Bullet Train
                provides a turnkey robust feature management solution that offers high availability, scalability, and
                audit control.
            </p>

            <p>
Because Bullet Train customers themselves have customers, language can get very confusing. In this
                document, we refer to our customers (Companies who utilize our platform in their software) as members
                (team members). We refer to the customers of those members to be "users" or "end-users". When the
                generic pronoun "you" is used, it is meant to refer to anyone reading this policy and can generically
                mean anyone who interacts with our website, a member of our services, or a user of one of our
                members.
            </p>

            <p>
This policy largely deals with members, how we keep their data safe, and how we are allowed to use their
                data. If you are an end-user of one of our member's services, then you should consult their privacy
                policy instead, as the member policy applies to the information collected instead of this policy. Bullet
                Train collects data from our members about their user under their direction, but we do not have a direct
                relationship with users themselves. This policy applies to the data as long as we retain the data.
            </p>

            <p>
This policy does not cover third party websites, products, or services even if they link to our
                services—you should consider their own privacy policies carefully. If you disagree with the practices
                described in this policy, then you should (a) take necessary steps to remove cookies from your computer
                after leaving our website, and (b) discontinue your use of our services.
            </p>

            <h5>How Do We Use Data?</h5>
            <p>
The data we collect depends on how our services are used. We receive some data directly, like when you
                visit one of our web properties, sign up for a trial, or send us email. Other times, we get data
                indirectly, like when we record that you visited one of our websites using technologies like cookies. We
                also get data from third parties, like from our members when they pass data to us to process.
            </p>

            <p>
The collection and use of data is essential to the value that we provide as a service, as well as improve
                on the services we provide; but we aim to do our best to keep data safe and secure.
            </p>

            <h5>Data We Collect</h5>
            <ol>
                <li>
                    <p>
                        <b>Personal Data.</b>
                        {' '}
                        We call data that identifies, or could be used to reasonably identify you as "Personal Data". We
                        collect Personal Data in various ways, like when you register for trial accounts or interact
                        with our sales team. Personal Data does not include data that has been anonymized,
                        psuedonymised, or minimized such that it cannot be reasonably associated with a person.
                    </p>
                </li>
                <li>
                    <p>
                        <b>Service Data.</b>
                        {' '}
                        We call data that our members send to us about their users "Service data". Bullet Train's core
                        service allows our members to submit details about their end-users to enrich their experiences
                        through our platform. Our members have a responsibility to understand the data they send to us
                        and to take the appropriate disclosures, precautions, and responsibilities regarding the content
                        of the service data they provide to us.
                    </p>
                </li>
                <li>
                    <p>
                        <b>Other Data.</b>
                        {' '}
                        We call any other data that is not Personal Data or Service Data "Other Data". We collect Other
                        Data through a variety of sources. One of those sources are cookies and other technologies that
                        record data about the use of our website. Other data that we may collect include:
                    </p>
                    <ul>
                        <li>
                            <p>
                                <b>Browser and device data</b>
                                , such as IP address, device type, operating system and internet browser type, screen
                                resolution, operating system name and version, device manufacturer and model, language,
                                plug-ins, add-ons and the version of the Services you are using;
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>Transaction data</b>
                                , such as purchases, purchase amount, date of purchase, and payment method that you have
                                submitted to us as a course of ordering our services;
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>Cookie and tracking technology data</b>
                                , such as time spent on the Services, pages visited, language preferences, and other
                                anonymous traffic data; and
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>Company data</b>
                                , such as a company's legal structure, product and service offerings, jurisdiction,
                                company records, and information submitted to us by you in interacting with our sales
                                team.
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>Browser and device data</b>
                                , such as IP address, device type, operating system and internet browser type, screen
                                resolution, operating system name and version, device manufacturer and model, language,
                                plug-ins, add-ons and the version of the Services you are using;
                            </p>
                        </li>
                    </ul>
                </li>
            </ol>

            <h5>How We Use Data</h5>
            <p>We collect information about our customers for the following reasons and not for other reasons:</p>

            <ol>
                <li>
                    <p>
                        <b>Personal Data.</b>
                        {' '}
                        We and our service providers use Personal Data to provide our Service. Examples of how we use
                        personal data include:
                    </p>
                </li>
                <ul>
                    <li><p>Enumerating you and your team for the purposes of access to our platform</p></li>
                    <li><p>To deliver information to your subscribed applications in order to provide service</p></li>
                    <li><p>To respond to inquiries, send service notices, and provide customer support</p></li>
                    <li><p>For audits, regulatory purposes, and compliance with industry standards</p></li>
                    <li><p>To develop new products</p></li>
                    <li><p>To send marketing communications</p></li>
                    <li><p>To improve or modify our services</p></li>
                    <li>
                        <p>
To conduct analysis and develop insights that enable us to operate, protect, make informed
                        decisions and report on our business.
                        </p>
                    </li>
                </ul>
                <li>
                    <p>
                        <b>Service Data.</b>
                        {' '}
                        We utilize service data for no purpose except to deliver the functionality that our platform
                        provides to our members.
                    </p>
                </li>
                <li>
                    <p>
                        <b>Other data.</b>
                        {' '}
                        We utilize other data in a number of ways, but we comply with applicable law and contractual
                        agreements. In some areas, like the European Economic Area Countries, we may be required to
                        treat Other Data like Personal data. In areas where this is the case, we will process this data
                        as if it were Personal data under our privacy policy.
                    </p>
                </li>
            </ol>

            <h5>How We Disclose Data</h5>
            <p>
Bullet Train does not sell Personal Data or Service Data to marketers or unaffiliated third parties. Data
                collected by Bullet Train will only used for the purposes of furthering, improving, and expanding the
                Bullet Train business. We share Personal and Service Data with the following third parties:
            </p>

            <ol>
                <li>
                    <p>
                        <b>To Bullet Train Service Providers.</b>
                        {' '}
                        In order to deliver the services that make up the Bullet Train Product, we rely on service
                        providers (e.g. infrastructure providers, and affiliated) to provide key functionality both in
                        the operation of our product as well as the operation of the Bullet Train company.
                    </p>
                </li>
                <li>
                    <p>
                        <b>To our members.</b>
                        {' '}
                        We process and collate service data that is provided to us by our members in order to deliver
                        the services to our members.
                    </p>
                </li>
                <li>
                    <p>
                        <b>To third parties.</b>
                        {' '}
                        In the event of a reorganization, merger, sale, joint venture, assignment, transfer of any part
                        of our business to third parties.
                    </p>
                </li>
                <li>
                    <p>
                        <b>Safety, Legal and Law Enforcement.</b>
                        {' '}
                        We use and disclose data as we believe necessary under the applicable law, to enforce our own
                        terms and conditions, to protect our rights, privacy, safety, or property, as well as to respond
                        to requests from courts, law enforcement, regulatory agencies, and government authorities, which
                        may include countries outside of your country of residence.
                    </p>
                </li>
            </ol>

            <h5>Security and Notification of Breaches</h5>
            <p>
                Bullet Train takes security very seriously, and if you have reason to believe that your data or someone
                elses data is no longer secure, please contact
                <a href="mailto:security@bullettrain.io">security@bullettrain.io.</a>
            </p>
            <p>
In the event of a security breach, we will take take necessary measures to ensure the continued safety of
                data and contact affected parties within a reasonable amount of time about the scope and scale of the
                unauthorized disclosure.
            </p>

            <h5>Retention Period</h5>
            <p>
We retain data as necessary to provide the services as described in this policy unless a longer retention
                is required by law. For personal data, we retain information about you until are no longer a customer,
                though some data is retained for the purposes of audit. Service data is retained for a period of no more
                than 30 days, save for data that is required as a part of audit control.
            </p>
            <p>
The above principals of how we will manage the data, use the data, protect the data, and remove the data
                will apply for as long as we control the Personal data.
            </p>

            <h5>User of Service by Minors</h5>
            <p>
Bullet Train's core services are not directed to minors and we request that minors do not provide to us
                any Personal Data. We rely on our members, when acting in the role of a Data controller, to take
                responsibility for making sure their users' privacy rights are respected and ensuring that the
                appropriate disclosures are made about third party collection and use.
            </p>

            <h5>Right to Access, View, or Remove Your Information</h5>
            <p>
You have a right to access the personal information we hold about you. Whenever you use our site or
                Bullet Train Services, we strive to make sure that your Personal Information is correct. If that
                information is wrong, we give you tools and methods to update it quickly or delete it, unless that
                information is necessary for legal or business purposes. When updating your Personal Information, we may
                ask you to verify your identity before making changes. We may reject requests that are unreasonably
                repetitive, require disproportionate technical effort (for example, developing new systems or
                fundamentally changing our existing practice), risk the privacy of others, or would be extremely
                impractical (e.g. requests concerning information on our backup systems). Because we protect information
                from accidental or malicious destruction, after data is removed from our servers, it can take some time
                for that data to be purged.
            </p>
            <p>
To request removal of your Personal Information from our site or services, contact us at
                privacy@bullettrain.io. Bullet Train cares deeply about the sanctity of your data and our privacy team
                will manage each request on a case by case basis.
            </p>
            <p>
We totally understand your right to have us stop contacting you. We endeavor to give you the ability to
                control the way we contact you. You may use the links at the bottom of each communication to opt-out
                of further communications.
            </p>
            <p>
If you are a user of one of our member's services and need to correct, amend, or delete inaccurate data
                about you, please contact the member—in this case, they are the data controllers. We will comply with
                the wishes of our members should they direct us to take action about the modification/removal of
                collected data.
            </p>

            <h5>Jurisdiction</h5>
            <p>
Our services are global and Data (of all classifications) may be stored and processed anywhere where we
                or one of our service providers has services. We may transfer data to countries outside of your country
                of residence, which may have different rules applicable to your data. Bullet Train will take measures to
                ensure that any transfers comply with applicable laws and your data remains protected as per this
                policy.
            </p>

            <h5>How do I contact the Bullet Train Data Privacy Officer?</h5>
            <p>
                Bullet Train's Data Privacy Officer is Matthew Elwell, and you can contact him at
                <a href="mailto:privacy@bullet-train.io">privacy@bullet-train.io.</a>
            </p>

            <h5>Is Bullet Train compliant with the General Data Protection Regulation (GDPR)?</h5>
            <p>
Bullet Train has taken steps to elect a Data Privacy Officer, to ensure that we have adequate data
                protection policies, procedures, and practices. We believe that we are fully in compliance with the
                provisions and principles of GDPR.
            </p>
        </div>
    </div>
);

PrivacyPolicyPage.displayName = 'PrivacyPolicyPage';
export default PrivacyPolicyPage;
